module.exports = __webpack_public_path__ + "img/verify_3.499e6e2f.png";